export default __webpack_public_path__ + "static/media/thumbnail_blog_10.0d62a186.png";